import React from 'react';
import { t } from 'i18next';
import { API } from 'aws-amplify';
import { Box, Typography, CircularProgress } from '@mui/material';

import RenderIf from '../../../renderIf';
import FileDrop from '../../../shared/FileDrop';
import useFileIO from '../../../../utils/file';
import { useStyles } from './styles';

const AttendanceRecord = ({ detailWizard, isFetching, downloadOnly = false, forceValidation }) => {
    const [doingAjax, setDoingAjax] = React.useState(true);
    const [file, setFile] = React.useState([]);

    const classes = useStyles();

    const valid = file.length === 1;

    const displayInvalid = (forceValidation === true || forceValidation === 'AttendanceRecordFileID') && !valid;

    const { UploadFile } = useFileIO?.();

    //#region InitialLoad
    const getFileData = async () => {
        if (Number.isInteger(detailWizard?.state?.AppInstInvoiceID)) {
            setDoingAjax(true);
            try {
                let { file } = await API.get('ShipyardAPI', `/finances/invoices/attendance/${detailWizard.state.AppInstInvoiceID}`);

                if (file) {
                    setFile([
                        {
                            name: file.FileName,
                            fileId: file.FileID,
                            uploadedOn: new Date(file.LastUpdatedUTC).toISOString(),
                            type: file.MIMEType,
                        },
                    ]);
                }
            } catch (e) {
                console.log(e);
            } finally {
                setDoingAjax(false);
            }
        }
    };

    React.useEffect(() => {
        if (!isFetching) {
            getFileData();
        }
    }, [isFetching]);
    //#endregion InitialLoad

    //#region Drop
    const drop = async (event) => {
        event?.preventDefault();
        event?.stopPropagation();

        setDoingAjax(true);

        let [_fileDropped] = event?.dataTransfer?.files || event?.target?.files;

        const _fileData = await UploadFile(_fileDropped, 12);

        setFile((prev) => [...prev, _fileData]);

        try {
            await API.post('ShipyardAPI', '/finances/invoices/attendance', {
                body: {
                    AppInstInvoiceID: detailWizard.state.AppInstInvoiceID,
                    FileID: _fileData.fileId,
                },
            });

            detailWizard.patch(
                Object.assign(detailWizard.state, {
                    FileID: _fileData.fileId,
                })
            );
        } catch (e) {
        } finally {
            setDoingAjax(false);
        }
    };
    //#endregion Drop

    //#region Drag
    const drag = (event) => {
        event?.preventDefault();
        event?.stopPropagation();
    };
    //#endregion Drag

    //#region Remove
    const remove = async () => {
        setDoingAjax(true);
        try {
            await API.del('ShipyardAPI', '/finances/invoices/attendance', {
                body: {
                    AppInstInvoiceID: detailWizard.state.AppInstInvoiceID,
                    FileID: file[0].fileId,
                },
            });

            setFile([]);
        } catch (e) {
            console.log(e);
        } finally {
            setDoingAjax(false);
        }
    };
    //#endregion Remove

    return (
        <Box>
            <Typography className={displayInvalid ? classes.required : null}>
                <RenderIf isTrue={!downloadOnly}>
                    <span className={classes.required}>*</span>
                </RenderIf>
                {t('Finances.Invoices.AttendanceRecord')}
            </Typography>
            <Box className={classes.flexBox}>
                <FileDrop
                    files={file}
                    required={true}
                    drop={drop}
                    dragover={drag}
                    remove={remove}
                    disabled={doingAjax || downloadOnly}
                    downloadOnly={downloadOnly}
                />

                <RenderIf isTrue={doingAjax}>
                    <CircularProgress sx={{ marginLeft: '3rem' }} />
                </RenderIf>
            </Box>
            <RenderIf isTrue={displayInvalid}>
                <Typography className={classes.failText}>(Attendance Record is required.)</Typography>
            </RenderIf>
        </Box>
    );
};

export default AttendanceRecord;
